var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOlfxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 38,
    viewBox: "0 0 155 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58899 30.436V15.308H0V38H22.7219V30.436H7.58899Z",
    fill: "#F6F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8324 0.157593H0V11.5036H7.56647V7.7666H30.2659V30.436H26.5052V38H37.8324V0.157593Z",
    fill: "#F6F7FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4663 0.0449829H57.1538V28.2298H73.9307V37.9549H45.4663V0.0449829Z",
    fill: "#F6F7FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3846 0H110.727V9.72512H93.0721V14.4526H108.228V23.4799H93.0721V37.9325H81.3621V0H81.3846Z",
    fill: "#F6F7FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.022 17.8294L115.591 0.157593H129.238L134.958 10.423L140.565 0.157593H153.491L141.376 17.942L154.865 37.955H140.835L134.395 26.6766L127.707 37.955H114.375L128.022 17.8519V17.8294Z",
    fill: "#F6F7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlfxLogo);
export default __webpack_public_path__ + "static/media/olfx_logo.8b651423483fc2e09d51b9f093ee6b00.svg";
export { ForwardRef as ReactComponent };